export default {
  title: 'Overfør website',
  buttons: {
    cancel: 'Annuller',
    transfer: 'Overfør',
  },
  fields: {
    target_franchise: {
      label: 'Målfranchise',
      description: 'Vælg den franchise, websitet skal overføres til',
    },
    sync_companies: {
      label: 'Virksomhedstilknytninger',
      description: 'Knyt virksomheder fra målfranchisen til storefront-virksomheder',
      franchise_company: 'Franchisevirksomhed',
      storefront_company: 'Storefront-virksomhed',
      select_franchise_company: 'Vælg franchisevirksomhed',
      select_storefront_company: 'Vælg storefront-virksomhed',
      franchise_company_required: 'Franchisevirksomhed er påkrævet',
      storefront_company_required: 'Storefront-virksomhed er påkrævet',
    },
  },
  toasts: {
    failed_to_load_companies: 'Virksomheder kunne ikke indlæses',
    no_companies_selected: 'Tilføj mindst én virksomhedstilknytning',
    failed_to_transfer: 'Websitet kunne ikke overføres',
    transfer_success: 'Websitet blev overført',
    franchise_already_connected: 'Målfranchisen er allerede forbundet til et website',
  },
};
